"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Conversion = _interopRequireDefault(require("@rsuite/icon-font/lib/action/Conversion"));

// Generated by script, don't edit it please.
var Conversion = (0, _createSvgIcon["default"])({
  as: _Conversion["default"],
  ariaLabel: 'conversion',
  category: 'action',
  displayName: 'Conversion'
});
var _default = Conversion;
exports["default"] = _default;
module.exports = exports.default;